import $ from 'jquery';
import { trackRegistrationSuccess } from './tracking/registration-success';

const KEYWORDS = {
	nangmui: [
		'nang mui s line',
		'nâng mũi s line',
		's line plus',
		'nang mui sụn sườn',
		'nang mui cấu trúc',
		'nâng mũi',
		'nâng mũi sline',
		'phau thuat mui',
		'phẫu thuật mũi',
		'thu gon cánh mũi',
		'thu gọn cánh mũi',
		'thu nhỏ cánh mũi',
		'thu nho mũi',
		'nâng mũi hàn quốc',
		'nang mui han quoc',
	],
	nangnguc: [
		'nâng ngực nội soi',
		'nang nguc noi soi',
		'nang nguc golden line',
		'nâng ngực nano chip giot nước',
		'nâng ngực túi giọt nước',
		'nâng ngực nano chip 3D',
		'nang nguc chay xe',
		'treo tuyến ngực',
		'thu gọn quầng vú',
		'thu gọn ngực',
		'thu gọn ngực phì đại',
		'phẫu thuật thẩm mỹ ngực',
		'tham mỹ ngực',
		'phau thuat tham my nguc',
	],
	mat: [
		'cat mat 2 mí',
		'cắt mắt 2 mí',
		'tham my mat to',
		'thẩm mỹ mắt to',
		'thẩm mỹ mắt',
		'bấm mí hàn quốc',
		'bam mi han quốc',
		'treo chan may noi soi',
		'treo chân mày nội soi',
		'treo chân mày',
		'điều trị sụp mí mắt',
		'dieu tri sup mi mat',
	],
	hammat: [
		'phẫu thuật hàm hô',
		'phau thuat ham ho',
		'cang da mat',
		'căng da mặt mesh lift',
		'căng da mặt smas',
		'cười hở lợi',
		'chữa cười hở lợi',
		'got mat vline',
		'gọi mặt v line',
		'độn cằm',
		'độn cằm v line',
		'gọt cằm v line',
		'mặt vline',
		'trượt cằm',
		'hạ gò má',
		'ha go ma',
		'độn thái dương',
		'độn rãnh mũi má',
		'cấy mỡ mặt baby face',
		'don thai dương',
		'cai lao guong mat',
		'cãi lão gương mặt',
		'dieu trị tre hoa',
		'điều trị trẻ hóa da',
		'thẩm mỹ điều trị da',
		'tham my dieu tri da',
		'tham my tre',
	],
	other: [
		'nang mong noi soi',
		'nâng mông nọi soi',
		'cang da bụng',
		'thẩm mỹ căng da bụng',
		'hút mỡ bụng smart lipo',
		'hút mỡ bụng laser lipo',
		'hut mo bung',
		'hut mo toan than',
		'hút mỡ toàn thân',
		'hút mỡ đùi',
		'căng da đùi',
		'trẻ hóa bằng chất làm đầy',
		'thẩm mỹ vùng kín đẹp',
		'phẫu thuật kéo núm vú',
		'hút mỡ an toàn',
		'hút mỡ bằng gì',
		'giảm mỡ cấp tốc',
	],
	nhakhoa: [
		'cấy ghép implant',
		'cấy ghép implant kỹ thuật số 4.0',
		'cấy ghép implant là gì',
		'implant nước',
		'cay ghep implant tuc thi',
		'cấy ghép all on4 all on6',
		'cáy ghép implant ứng dụng màng tế bào',
		'niềng răng',
		'nieng rang',
		'niềng răng smart',
		'niềng răng trong suốt ai',
		'niềng răng kỹ thuật số 4.0',
		'niềng răng mắc cài sứ',
		'mắc cài kim loại',
		'niềng răng invisalign',
		'niềng răng mặt trong',
		'nha khoa thẩm mỹ',
		'bọc răng sứ kỹ thuật số 4.0',
		'boc rang su',
		'dán sứ vener',
		'bọc răng sứ lava 3m',
		'bọc răng sứ zirconia',
		'bọc răng sứ lisi',
		'tẩy trắng răng',
		'nha khoa trẻ em',
		'nhổ răng khôn',
		'chữa bệnh nha chu',
		'cạo voi răng',
		'làm trắng răng',
	],
	skince: [
		'điều trị nám',
		'điều trị tàn nhang',
		'dieu tri nam',
		'tri mun',
		'điều trị mụn',
		'tri seo',
		'tham my dieu tri seo',
		'điều trị sẹo mụn',
		'xóa nốt ruồi',
		'triệt lông tay',
		'triệt lông toàn thân',
		'xóa lông chân',
		'trẻ hóa nâng cơ hifu smas',
		'tiêm meso',
		'meso baby skin',
		'xóa nhăn duolift 4.0',
		'trẻ hóa da aifracell',
		'cấy tinh chất collagen',
		'điêu khắc chân mày',
		'khắc chân mày nam giới 6D',
		'phun xăm mí mắt',
		'phun môi thẩm mỹ',
		'thẩm mỹ điều trị nám',
		'thẩm mỹ tiêm meso trẻ hóa',
		'tinh chat collagen',
		'thẩm mỹ môi trái tim',
		'điêu khắc chân mày phông thủy',
		'trẻ hóa làn da',
		'tiêm meso là gì',
	],
	book: ['sách nghèo là vốn liếng', 'sach ngheo la von lieng'],
	price: [
		'gia phau thuat tham my',
		'giá phẩu thuật thẩm mỹ',
		'bảng giá phẩu thuật thẩm mỹ',
		'phẩu thuật nâng ngực giá bao nhiêu',
		'thẩm mỹ điều trị sẹo giá bao nhiêu',
		'bảng giá điều trị hàm hô',
		'bảng giá điều trị hàm móm',
	],
	doctor: [
		'tú dung',
		'bác sĩ tú dung',
		'bac si nguyen phan tu dung',
		'bệnh viện bác sĩ tú dung',
		'nguyễn phan tú dung',
		'cơ sở vật chất bệnh viện jw hàn quốc',
		'bệnh viện jw thành lập năm bao nhiêu',
	],
};

const OPTIONS = Object.values(KEYWORDS).flat();
const NEXT_ICON = '<svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 640 640"><path fill="#ffffff" d="M64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM305 441C295.6 450.4 280.4 450.4 271.1 441C261.8 431.6 261.7 416.4 271.1 407.1L358.1 320.1L271.1 233.1C261.7 223.7 261.7 208.5 271.1 199.2C280.5 189.9 295.7 189.8 305 199.2L409 303C418.4 312.4 418.4 327.6 409 336.9L305 441z"/></svg>';
const PREV_ICON = '<svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 640 640"><path fill="#ffffff" d="M576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320zM335 199C344.4 189.6 359.6 189.6 368.9 199C378.2 208.4 378.3 223.6 368.9 232.9L281.9 319.9L368.9 406.9C378.3 416.3 378.3 431.5 368.9 440.8C359.5 450.1 344.3 450.2 335 440.8L231 337C221.6 327.6 221.6 312.4 231 303.1L335 199z"/></svg>';

export default class CustomUiController {
	constructor() {
		this.$ = $;
		this.initialized = false;
		this.layoutCache = new WeakMap();
		this.windowDimensions = {
			width: window.innerWidth,
			height: window.innerHeight,
			scrollY: window.pageYOffset || document.documentElement.scrollTop,
		};
		this.handleResize = this.debounce(() => this.onResize(), 250);
		this.handleProgressScroll = this.handleProgressScroll.bind(this);
		this.handleHeaderScroll = this.handleHeaderScroll.bind(this);
		this.handleWindowOrientation = this.handleWindowOrientation.bind(this);
		this.handleNavigationStateReset = this.resetNavigationLoadingState.bind(this);
		this.priceTabLoaderTimer = null;
		this.syncPriceTabFromLocation = null;
		this.mobileMenuResetSpinners = null;
		this.progressTicking = false;
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		this.updateWindowCache();
		this.initCarousels();
		this.initFadeCarousels();
		this.initSlickCarousels();
		this.initFormInteractions();
		this.initLegacyRegistrationForms();
		this.initPopupModal();
		this.initBackToTop();
		this.initScrollTo();
		this.initCounterAnimation();
		this.initGalleryAndMenu();
		this.initMenuBehavior();
		this.initPriceTabs();
		this.initLegacyMenuInteractions();
		this.initTabSwitching();
		this.initDoctorGallery();
		this.initVideoPlayer();
		this.initYoutubeEmbeds();
		this.initFloatingContactToggles();
		this.initStickyTargets();
		this.initScrollProgress();
		this.initIconDismiss();
		this.handleResponsiveAdjustments();
		this.handleHeaderScroll();
		window.addEventListener('resize', this.handleResize, { passive: true });
		window.addEventListener('orientationchange', this.handleWindowOrientation);
		window.addEventListener('scroll', this.handleHeaderScroll, { passive: true });
		window.addEventListener('pageshow', this.handleNavigationStateReset);
		window.addEventListener('pagehide', this.handleNavigationStateReset);
		window.addEventListener('popstate', this.handleNavigationStateReset);
		this.resetNavigationLoadingState();
	}
	// reset navigation loading state by hiding spinners and reset spinners on legacy menu
	resetNavigationLoadingState(event) {
		this.hideSpinnerLoader();
		this.mobileMenuResetSpinners?.();

		if ('popstate' === event?.type || 'pageshow' === event?.type) {
			this.syncPriceTabFromLocation?.();
		}
	}

	debounce(func, wait) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func(...args), wait);
		};
	}

	throttle(func, limit) {
		let inThrottle = false;
		return (...args) => {
			if (inThrottle) {
				return;
			}

			inThrottle = true;
			func(...args);
			window.setTimeout(() => {
				inThrottle = false;
			}, limit);
		};
	}

	updateWindowCache() {
		this.windowDimensions = {
			width: window.innerWidth,
			height: window.innerHeight,
			scrollY: window.pageYOffset || document.documentElement.scrollTop,
		};
	}

	clearLayoutCache() {
		this.layoutCache = new WeakMap();
	}

	smoothScrollTo(target, duration = 1000) {
		const targetElement = document.querySelector(target);
		if (!targetElement) {
			return;
		}

		const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 250;
		const startPosition = window.pageYOffset;
		const distance = targetPosition - startPosition;
		let startTime = null;

		const animate = (currentTime) => {
			if (startTime === null) {
				startTime = currentTime;
			}

			const timeElapsed = currentTime - startTime;
			const progress = Math.min(timeElapsed / duration, 1);
			const easeInOutQuad = progress < 0.5
				? 2 * progress * progress
				: 1 - Math.pow(-2 * progress + 2, 2) / 2;

			window.scrollTo(0, startPosition + distance * easeInOutQuad);

			if (timeElapsed < duration) {
				window.requestAnimationFrame(animate);
			}
		};

		window.requestAnimationFrame(animate);
	}

	destroyOwl($element) {
		if (!$element.length || !$element.data('owl.carousel')) {
			return;
		}

		$element.trigger('destroy.owl.carousel');
		$element.removeClass('owl-loaded owl-hidden');
		$element.find('.owl-stage-outer').children().unwrap();
		$element.find('.owl-stage').children().unwrap();
		$element.find('.owl-item').children().unwrap();
	}

	initOwlCarousel(selector, config) {
		const $element = this.$(selector);
		if (!$element.length || typeof this.$.fn.owlCarousel === 'undefined') {
			return;
		}

		this.destroyOwl($element);
		$element.owlCarousel(config);
	}

	initCarousels() {
		const commonConfig = {
			lazyLoad: true,
			autoplayHoverPause: true,
			smartSpeed: 450,
			fluidSpeed: 450,
			dragEndSpeed: 350,
			navSpeed: 450,
		};

		this.initOwlCarousel('.owl-index-news', {
			...commonConfig,
			items: 2,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			dots: false,
			nav: true,
			navText: ['', ''],
			responsive: {
				0: { items: 1, center: true },
				600: { items: 2, center: true },
				991: { items: 2, center: false },
			},
		});

		this.initOwlCarousel('.owl-index-news_mv', {
			...commonConfig,
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			dots: false,
			nav: true,
			navText: ['', ''],
		});

		this.initOwlCarousel('.owl__slider', {
			...commonConfig,
			items: 1,
			loop: true,
			autoplay: false,
			autoplayTimeout: 5000,
			nav: true,
			navText: ['', ''],
			dots: false,
		});

		this.initOwlCarousel('.owl__tesmo', {
			...commonConfig,
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 4000,
			nav: true,
			navText: ['', ''],
			dots: false,
		});

		this.initOwlCarousel('.owl_service', {
			...commonConfig,
			items: 4,
			loop: true,
			autoplay: true,
			autoplayTimeout: 3000,
			dots: false,
			nav: true,
			navText: ['', ''],
			responsive: {
				0: { items: 3, center: true },
				600: { items: 3, center: true },
				991: { items: 4, center: false },
			},
		});

		this.initOwlCarousel('.owl_why', {
			...commonConfig,
			items: 4,
			loop: true,
			autoplay: false,
			dots: false,
			nav: true,
			navText: ['', ''],
			responsive: {
				0: { items: 2 },
				1000: { items: 4 },
			},
		});

		this.initOwlCarousel('.owl_video', {
			...commonConfig,
			items: 3,
			center: true,
			loop: true,
			autoplay: false,
			dots: false,
			nav: true,
			mouseDrag: false,
			touchDrag: false,
			pullDrag: false,
			freeDrag: false,
			navText: ['', ''],
		});

		this.initOwlCarousel('.owl_story', {
			...commonConfig,
			items: 3,
			loop: true,
			autoplay: false,
			autoplayTimeout: 5000,
			dots: false,
			nav: true,
			navText: ['', ''],
			responsive: {
				0: { items: 1 },
				600: { items: 2 },
				1000: { items: 3 },
			},
		});

		this.initOwlCarousel('.owl_partner', {
			...commonConfig,
			items: 5,
			loop: true,
			autoplay: false,
			autoplayTimeout: 4000,
			dots: false,
			nav: true,
			navText: ['', ''],
			responsive: {
				0: { items: 5 },
				769: { items: 4 },
			},
		});

		this.initOwlCarousel('.owl__slide', {
			...commonConfig,
			items: 1,
			loop: true,
			autoplay: true,
			animateOut: 'fadeOut',
			autoplayTimeout: 4000,
			nav: true,
			navText: ['', ''],
			dots: false,
		});

		this.initOwlCarousel('.owl__feedback', {
			...commonConfig,
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			dots: true,
			nav: false,
		});

		if (this.windowDimensions.width > 768) {
			this.$('#banner-index .item img.visible-xs').remove();
		} else {
			this.$('#banner-index .item img.hidden-xs').remove();
		}

		this.initOwlCarousel('#banner-index', {
			items: 1,
			center: true,
			loop: true,
			autoplay: 5000,
			dots: false,
			nav: true,
			autoplayHoverPause: true,
			lazyLoad: true,
			navText: [
				"<i class='fa fa-chevron-left'></i>",
				"<i class='fa fa-chevron-right'></i>",
			],
		});

		this.initOwlCarousel('#story-slide', {
			items: 4,
			singleItem: true,
			slideBy: 1,
			dotsEach: true,
			autoplay: false,
			loop: true,
			margin: 0,
			nav: true,
			dots: false,
			autoplayHoverPause: true,
			navText: [
				"<i class='fa fa-chevron-left' aria-hidden='true'></i>",
				"<i class='fa fa-chevron-right' aria-hidden='true'></i>",
			],
		});

		this.$('#doctor-slide').on('touchstart', (event) => event.preventDefault());
		this.initOwlCarousel('#doctor-slide', {
			singleItem: true,
			slideBy: 1,
			dotsEach: true,
			loop: false,
			mouseDrag: false,
			touchDrag: false,
			pullDrag: false,
			rewind: true,
			autoplay: false,
			margin: 15,
			nav: true,
			dots: false,
			navText: [
				"<i class='fa fa-chevron-left' aria-hidden='true'></i>",
				"<i class='fa fa-chevron-right' aria-hidden='true'></i>",
			],
			responsive: {
				0: { items: 2 },
				480: { items: 2 },
				768: { items: 4 },
			},
		});

		this.initOwlCarousel('#top-news', {
			items: 1,
			loop: true,
			autoplay: true,
			dots: true,
			nav: false,
			lazyLoad: true,
		});

		this.initOwlCarousel('#footer-news', {
			items: 3,
			loop: true,
			autoplay: false,
			dots: false,
			nav: true,
			lazyLoad: true,
			navText: [
				"<i class='fa fa-chevron-left' aria-hidden='true'></i>",
				"<i class='fa fa-chevron-right' aria-hidden='true'></i>",
			],
			responsiveClass: true,
			responsive: {
				0: { items: 1, nav: true },
				600: { items: 3, nav: true },
				1000: { items: 3, nav: true },
			},
		});

		this.initOwlCarousel('#footer-related-post', {
			items: 3,
			loop: true,
			autoplay: false,
			dots: false,
			nav: true,
			lazyLoad: true,
			navText: [
				"<i class='fa fa-chevron-left' aria-hidden='true'></i>",
				"<i class='fa fa-chevron-right' aria-hidden='true'></i>",
			],
			responsiveClass: true,
			responsive: {
				0: { items: 1, nav: true },
				600: { items: 3, nav: true },
				1000: { items: 3, nav: true },
			},
		});

		this.bindBootstrapCarouselControls('#custom_carousel');
		this.bindBootstrapCarouselControls('#doctor-carousel');
		this.bindBootstrapCarouselControls('#customer-carousel');
	}

	initFadeCarousels() {
		if (!this.$ || typeof this.$.fn.owlCarousel === 'undefined') {
			return;
		}

		const basicConfig = {
			items: 1,
			loop: true,
			lazyLoad: true,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplayHoverPause: false,
			dots: true,
			dotsEach: true,
			nav: true,
			navText: [PREV_ICON, NEXT_ICON],
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			smartSpeed: 600,
			autoWidth: false,
			stagePadding: 0,
			margin: 0,
		};

		const attachScrollToDKForm = ($carousel) => {
			if (!$carousel || !$carousel.length) {
				return;
			}

			$carousel
				.off('click.scrollToDKForm', '.scroll-to-form-dk')
				.on('click.scrollToDKForm', '.scroll-to-form-dk', (event) => {
					event.preventDefault();

					const $trigger = this.$(event.currentTarget);

					let $dkForm = $trigger
						.closest('.from-dk-service-sigle')
						.find('.from-dk')
						.first();

					if (!$dkForm.length) {
						$dkForm = $trigger
							.closest('.tab-pane')
							.find('.from-dk')
							.first();
					}

					if (!$dkForm.length) {
						return;
					}

					const headerOffset = 100;
					const top = $dkForm.offset().top - headerOffset;

					window.scrollTo({
						top,
						behavior: 'smooth',
					});
				});
		};

		const initFadeCarousel = ($element, config = {}) => {
			if (!$element.length) {
				return;
			}

			this.destroyOwl($element);

			$element
				.off('initialized.owl.carousel.jwFade refreshed.owl.carousel.jwFade')
				.on('initialized.owl.carousel.jwFade refreshed.owl.carousel.jwFade', (event) => {
					const $target = this.$(event.target);
					this.decorateDots($target);

					if ($target.is('.price-list-owl-carousel')) {
						attachScrollToDKForm($target);
					}
				});

			$element.owlCarousel({
				...basicConfig,
				...config,
			});

			this.decorateDots($element);

			if ($element.is('.price-list-owl-carousel')) {
				attachScrollToDKForm($element);
			}
		};

		initFadeCarousel(this.$('#banner-index'));
		initFadeCarousel(this.$('#banner-index-mb'));

		const currentUrl = window.location.href;

		if (currentUrl.includes('bang-gia-tham-my-jw')) {
			initFadeCarousel(this.$('.price-list-owl-carousel'), {
				autoplay: false,
				items: 1.5,
				margin: 10,
				dots: false,
				dotsEach: false,
				responsive: {
					0: {
						items: 1.5,
					},
					600: {
						items: 1.75,
					},
				},
			});
		}
	}

	decorateDots($target) {
		$target.find('.owl-dot').each((index, dot) => {
			const label = `Slide ${index + 1}`;
			const $button = this.$('<button type="button" class="tmhq-dot-btn"></button>')
				.attr('aria-label', label)
				.text(index + 1);

			this.$(dot).empty().append($button);
		});
	}

	bindBootstrapCarouselControls(selector) {
		const $carousel = this.$(selector);
		if (!$carousel.length) {
			return;
		}

		$carousel.off('slide.bs.carousel.jwTheme').on('slide.bs.carousel.jwTheme', (event) => {
			this.$(`${selector} .controls li.active`).removeClass('active');
			this.$(`${selector} .controls li:eq(${this.$(event.relatedTarget).index()})`).addClass('active');

			if (selector === '#custom_carousel') {
				const $related = this.$(event.relatedTarget);
				const $titleImage = $related.find('img[data-title]');
				const $sourceImage = $related.find('img[data-src]');
				$titleImage.attr('src', $titleImage.data('title'));
				$sourceImage.attr('src', $sourceImage.data('src'));
			}
		});
	}

	initSlickCarousels() {
		if (typeof this.$.fn.slick === 'undefined' || !this.$('.customer-slick-vertical').length) {
			return;
		}

		if (this.$('.customer-slick-vertical').hasClass('slick-initialized')) {
			this.$('.customer-slick-vertical').slick('unslick');
		}

		this.$('.customer-slick-vertical').slick({
			vertical: true,
			infinite: true,
			dots: true,
			focusOnSelect: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			lazyLoad: 'ondemand',
			responsive: [
				{
					breakpoint: 991,
					settings: { vertical: false },
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						vertical: false,
					},
				},
			],
		});
	}

	initFormInteractions() {
		this.$(document).off('click.jwTheme', '#btn-index-reg').on('click.jwTheme', '#btn-index-reg', (event) => {
			event.preventDefault();
			const input = document.querySelector('.frm-index-focus .input-group label input');
			if (input) {
				input.focus();
				input.classList.add('focus-active');
			}
		});
	}

	initLegacyRegistrationForms() {
		this.$('#btn-submit').off('click.jwTheme').on('click.jwTheme', (event) => {
			event.preventDefault();
			this.submitRegisterForm({
				name: '#txtName',
				phone: '#txtPhone',
				ip: '#ip',
				note: '#txtNote',
				source: '#source',
				campaign: '#campaign',
				position: '#position',
				city: '#city',
				error: '#error-form-zone',
				dataArea: '#data-area',
				form: '#home-form',
			});
		});

		this.$('#btn-submit-pop').off('click.jwTheme').on('click.jwTheme', (event) => {
			event.preventDefault();
			this.submitRegisterForm({
				name: '#txtNamePop',
				phone: '#txtPhonePop',
				ip: '#ipPop',
				note: '#txtNotePop',
				source: '#source_pop',
				campaign: '#campaign_pop',
				position: 'popup',
				city: '#city-pop',
				error: '#error-form-zone-pop',
				dataArea: '#data-area-pop',
				form: '#popup-form',
				modal: '#modal-id',
			});
		});
	}

	getCookie(name) {
		const cookieName = `${name}=`;
		const cookies = document.cookie.split(';');
		for (let index = 0; index < cookies.length; index += 1) {
			let cookie = cookies[index];
			while (cookie.charAt(0) === ' ') {
				cookie = cookie.substring(1);
			}

			if (cookie.indexOf(cookieName) === 0) {
				return cookie.substring(cookieName.length, cookie.length);
			}
		}

		return '';
	}

	hasCookie(name) {
		return this.getCookie(name) !== '';
	}

	setCookie(name, value, days) {
		const expires = new Date();
		expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${value}; expires=${expires.toUTCString()}`;
	}

	isValidPhoneNumber(phoneNumber) {
		let value = phoneNumber
			.replace('(+84)', '0')
			.replace('+84', '0')
			.replace('0084', '0')
			.replace(/ /g, '');

		if (value === '') {
			return false;
		}

		const prefix = value.substring(0, 2);
		if (['09', '08', '07', '05', '03'].includes(prefix) && value.length === 10) {
			return /^\d{10}/.test(value);
		}

		if (prefix === '01' && value.length === 11) {
			return /^\d{11}/.test(value);
		}

		return false;
	}

	resolveServicePost() {
		const cookiePost = this.$('.entry-content .cookie-post');
		if (cookiePost.hasClass('cookie-nk')) {
			return 'nhakhoa';
		}

		if (cookiePost.hasClass('cookie-sk')) {
			return 'skincare';
		}

		return 'thammy';
	}

	submitRegisterForm(config) {
		const fullName = this.$(config.name).val();
		const telNumber = this.$(config.phone).val();
		const ip = this.$(config.ip).val();
		const message = this.$(config.note).val();
		const source = this.$(config.source).val();
		const campaign = this.$(config.campaign).val();
		const position = typeof config.position === 'string' && config.position.startsWith('#')
			? this.$(config.position).val()
			: config.position;
		const city = this.$(config.city).val();
		const servicePost = this.resolveServicePost();
		const $error = this.$(config.error);

		if (Number(this.getCookie('register')) > 10) {
			$error.html('Vui lòng thử lại!');
			return;
		}

		if (!fullName || fullName.length < 3) {
			$error.html('Vui lòng nhập đầy đủ họ tên');
			return;
		}

		if (!this.isValidPhoneNumber(telNumber)) {
			$error.html('Số điện thoại không hợp lệ');
			return;
		}

		$error.html('Hệ thống đang xử lý...');
		this.$.ajax({
			type: 'POST',
			url: 'https://thammyhanquoc.vn/wp-content/themes/jw-zw/register-form.php',
			data: {
				fullName,
				telNumber,
				position,
				ip,
				city,
				service_post: servicePost,
				source,
				campaign,
				message,
			},
			dataType: 'html',
			success: (response) => {
				if (parseInt(response, 10) === 0) {
					return;
				}

				if (/^\s*<script>\s*window\.location\s*=\s*["']https:\/\/thammyhanquoc\.vn\/cam-on["'];?\s*<\/script>\s*$/.test(response)) {
					trackRegistrationSuccess('legacy_registration', () => {
						window.location.href = 'https://thammyhanquoc.vn/cam-on';
					});
				} else {
					this.$(config.dataArea).html(response);
				}
				$error.html('');
				const form = document.querySelector(config.form);
				if (form) {
					form.reset();
				}

				if (config.modal && this.$(config.modal).length && typeof this.$(config.modal).modal === 'function') {
					this.$(config.modal).modal('hide');
				}

				const registerCount = this.hasCookie('register') ? Number(this.getCookie('register')) + 1 : 1;
				this.setCookie('register', registerCount, 1);
			},
		});
	}

	initPopupModal() {
		if (sessionStorage.getItem('#popup') === 'true') {
			return;
		}

		const showModal = () => {
			const modal = document.getElementById('modal-popup-live');
			if (modal && typeof this.$(modal).modal === 'function') {
				this.$(modal).modal('show');
			}
		};

		window.setTimeout(showModal, 2000);
		sessionStorage.setItem('#popup', 'true');
	}

	initBackToTop() {
		const backToTopBtn = document.querySelector('.back-to-top');
		if (!backToTopBtn) {
			return;
		}

		const handleScroll = this.throttle(() => {
			const shouldShow = window.pageYOffset > 220;
			backToTopBtn.classList.toggle('visible', shouldShow);
		}, 100);

		window.addEventListener('scroll', handleScroll, { passive: true });
		backToTopBtn.addEventListener('click', (event) => {
			event.preventDefault();
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		});
	}

	initScrollTo() {
		this.$(document).off('click.jwThemeScroll', '.scrollTo').on('click.jwThemeScroll', '.scrollTo', (event) => {
			event.preventDefault();
			const target = this.$(event.currentTarget).attr('href');
			if (target) {
				this.smoothScrollTo(target, 1500);
			}
		});
	}

	initCounterAnimation() {
		const counters = document.querySelectorAll('.countNumbers__number');
		if (!counters.length) {
			return;
		}

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting || entry.target.dataset.animated) {
					return;
				}

				entry.target.dataset.animated = 'true';
				this.animateCounter(entry.target);
				observer.unobserve(entry.target);
			});
		}, {
			threshold: 0.5,
			rootMargin: '0px',
		});

		counters.forEach((counter) => observer.observe(counter));
	}

	animateCounter(element) {
		const target = parseInt(element.textContent, 10);
		const duration = 3000;
		const startTime = performance.now();

		const updateCounter = (currentTime) => {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const easeOutQuart = 1 - Math.pow(1 - progress, 4);
			element.textContent = Math.ceil(target * easeOutQuart);

			if (progress < 1) {
				window.requestAnimationFrame(updateCounter);
			} else {
				element.textContent = target;
			}
		};

		window.requestAnimationFrame(updateCounter);
	}

	sanitizeInput(input) {
		return input
			.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
			.replace(/javascript:[^'"<>\s]+/gi, '')
			.replace(/<[^>]+>/gi, '');
	}

	initGalleryAndMenu() {
		this.initImageModal();

		if (this.$('#dr-container').length && typeof this.$.fn.gallery === 'function') {
			this.$('#dr-container').gallery();
		}

		this.positionDropdownMenus();
	}

	initImageModal({
		modalId = 'popupModalMmarquee',
		imageSelector = '.imageModalCn',
		imageTargetId = 'popupImageMarquee',
		closeBtnClass = '.popup-close-marquee',
	} = {}) {
		const modal = document.getElementById(modalId);
		const modalImage = document.getElementById(imageTargetId);
		const closeButton = modal?.querySelector(closeBtnClass);

		if (!modal || !modalImage || !closeButton) {
			return;
		}

		document.querySelectorAll(imageSelector).forEach((image) => {
			image.addEventListener('click', () => {
				modal.style.display = 'block';
				modalImage.src = image.src;
				modalImage.alt = image.alt || '';
			});
		});

		closeButton.addEventListener('click', () => {
			modal.style.display = 'none';
		});

		modal.addEventListener('click', (event) => {
			if (event.target === modal) {
				modal.style.display = 'none';
			}
		});
	}

	positionDropdownMenus() {
		const menuItems = document.querySelectorAll('li.menu-item.dropdown');
		if (!menuItems.length) {
			return;
		}

		window.requestAnimationFrame(() => {
			const allMenuItems = Array.from(document.querySelectorAll('li.menu-item'));
			const totalItems = allMenuItems.length;

			menuItems.forEach((item) => {
				const actualIndex = allMenuItems.indexOf(item);
				const rect = item.getBoundingClientRect();
				const parentRect = item.parentElement.getBoundingClientRect();
				const currentLeft = rect.left - parentRect.left;
				let left = '0';
				let right = 'unset';

				if (actualIndex > 0 && actualIndex < totalItems - 3) {
					left = `${currentLeft}px`;
				}

				if (actualIndex >= totalItems - 3) {
					left = 'unset';
					right = '0';
				}

				const dropdown = item.querySelector('.dropdown-menu.top-menu');
				if (dropdown) {
					dropdown.style.left = left;
					dropdown.style.right = right;
				}
			});
		});
	}

	initMenuBehavior() {
		const isDesktop = this.windowDimensions.width > 991;
		if (isDesktop) {
			document.querySelectorAll('li.menu-item-type-custom.dropdown').forEach((item) => {
				item.classList.add('use-css-hover');
			});
			return;
		}

		this.$(document)
			.off('click.jwThemeMenu', 'li.menu-item-type-custom.dropdown')
			.on('click.jwThemeMenu', 'li.menu-item-type-custom.dropdown', function() {
				const $item = $(this);
				if ($item.hasClass('open')) {
					$item.removeClass('open');
					return;
				}

				$('li.menu-item-type-custom.dropdown').removeClass('open');
				$item.addClass('open');
			});

		this.$('li.menu-item-type-custom.dropdown').each(function() {
			if (!$(this).find('.dropdown-menu.top-menu').length) {
				$(this).removeClass('dropdown');
			}
		});
	}

	initPriceTabs() {
		const tabs = Array.from(document.querySelectorAll('.tab_service a, .mobi_price_menu_ul a'));
		if (!tabs.length) {
			return;
		}

		const tabPanes = Array.from(document.querySelectorAll('.tab-pane'));
		const tabItems = Array.from(document.querySelectorAll('.tab_service li, .mobi_price_menu_ul li'));
		const priceContainer = document.querySelector('.price_total') || document;

		this.ensureSpinnerLoader();

		const activateTab = (tab, shouldScroll = true) => {
			if (!(tab instanceof HTMLElement)) {
				return;
			}

			tabs.forEach((tabLink) => tabLink.classList.remove('active_background'));
			tabPanes.forEach((pane) => pane.classList.remove('active'));
			tabItems.forEach((item) => item.classList.remove('active-mobi', 'active'));

			tab.classList.add('active_background');
			tab.closest('li')?.classList.add('active-mobi', 'active');

			const targetId = tab.getAttribute('aria-controls') || tab.getAttribute('href')?.replace('#', '');
			if (targetId) {
				document.getElementById(targetId)?.classList.add('active');
			}

			if (shouldScroll) {
				window.setTimeout(() => {
					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					});
				}, 100);
			}
		};
		// Sync price tab from location hash on page load
		this.syncPriceTabFromLocation = () => {
			const currentHash = window.location.hash.substring(1);
			const matchedTab = currentHash
				? tabs.find(
						(tab) =>
							tab.getAttribute('aria-controls') === currentHash ||
							tab.getAttribute('href') === `#${currentHash}`
				  )
				: tabs[0];

			if (matchedTab) {
				activateTab(matchedTab, false);
			}
		};

		priceContainer.addEventListener('click', (event) => {
			const priceTab = event.target.closest('.tab_service a, .mobi_price_menu_ul a');
			// Click on price tab
			if (priceTab && priceContainer.contains(priceTab)) {
				event.preventDefault();
				this.showSpinnerLoader();
				activateTab(priceTab);
				this.clearPriceTabLoaderTimer();
				//Only show loader for 500ms
				this.priceTabLoaderTimer = window.setTimeout(() => {
					this.priceTabLoaderTimer = null;
					this.hideSpinnerLoader();
				}, 500);
				return;
			}
			// Click on legacy tab
			const legacyTab = event.target.closest('a[data-toggle="tab"]');
			if (legacyTab && priceContainer.contains(legacyTab)) {
				event.preventDefault();
				legacyTab.closest('li')?.classList.add('active-mobi');
			}
		});

		if (window.location.hash.substring(1)) {
			this.syncPriceTabFromLocation();
		}
	}

	clearPriceTabLoaderTimer() {
		if (!this.priceTabLoaderTimer) {
			return;
		}

		window.clearTimeout(this.priceTabLoaderTimer);
		this.priceTabLoaderTimer = null;
	}

	showSpinnerLoader() {
		const loader = this.ensureSpinnerLoader();
		loader.classList.add('is-active');
		loader.style.display = 'block';
		loader.setAttribute('aria-hidden', 'false');
	}

	hideSpinnerLoader() {
		this.clearPriceTabLoaderTimer();
		const loader = document.getElementById('spinner-loader');
		if (!loader) {
			return;
		}

		loader.classList.remove('is-active');
		loader.style.display = 'none';
		loader.setAttribute('aria-hidden', 'true');
	}

	ensureSpinnerLoader() {
		let loader = document.getElementById('spinner-loader');
		if (loader) {
			return loader;
		}

		loader = document.createElement('div');
		loader.id = 'spinner-loader';
		loader.setAttribute('aria-hidden', 'true');
		loader.innerHTML = `
			<div class="loader-overlay">
				<div class="loader-spinner" role="status" aria-live="polite">
					<div class="spinner"></div>
					<p>Đang tải...</p>
				</div>
			</div>
		`;
		document.body.appendChild(loader);
		return loader;
	}


	initLegacyMenuInteractions() {
		if (window.JWSidebarMenuDelegatedReady) {
			return;
		}

		window.JWSidebarMenuDelegatedReady = true;
		const queryAll = (selector, context = document) =>
			Array.from(context.querySelectorAll(selector));
		const layerStack = [];
		let layerAnimationId = 0;
		const cachedElements = {
			sidebar: document.getElementById('header-sidebar'),
			menuButton: document.querySelector('.icon-menu'),
			menuIcon: document.querySelector('.menu-icon-3'),
			layer: document.querySelector('[data-mobile-menu-layer]'),
			layerTitle: document.querySelector('[data-mobile-menu-title]'),
			layerContent: document.querySelector('[data-mobile-menu-content]'),
		};
		const getCurrentElements = () => cachedElements;

		const getBootstrapOffcanvas = (sidebar) => {
			if (!window.bootstrap?.Offcanvas || !sidebar) {
				return null;
			}

			return window.bootstrap.Offcanvas.getOrCreateInstance(sidebar, {
				backdrop: true,
				scroll: false,
			});
		};

		const prepareDrilldownToggles = (context) => {
			queryAll('[data-toggle="submenu"]', context).forEach((toggle) => {
				toggle.setAttribute('role', 'button');
				toggle.setAttribute('tabindex', '0');
				toggle.setAttribute('aria-expanded', 'false');
				toggle.setAttribute('aria-haspopup', 'true');
				toggle.classList.add('mobile-menu-drilldown-trigger');
			});
		};
		// Reset loading spinners on sidebar close
		const resetLinkLoadingSpinners = (context = document) => {
			if (!context?.querySelectorAll) {
				return;
			}

			context
				.querySelectorAll('[data-mobile-menu-loading-link]')
				.forEach((link) => {
					const content = link.dataset.currentLoadingContent;
					if (content) {
						link.textContent = content;
						delete link.dataset.currentLoadingContent;
					}

					const icon = link.nextElementSibling;
					if (icon?.classList.contains('fa-circle-notch')) {
						icon.classList.replace(
							'fa-circle-notch',
							'fa-circle-chevron-right'
						);
					}
					icon?.classList.remove('fa-spin');
				});
		};

		const sanitizeLayerList = (list) => {
			list.removeAttribute('id');
			list.classList.add('mobile-menu-layer__list');
			list.classList.remove('open', 'show-submenu-child');
			list.removeAttribute('style');

			queryAll('[id]', list).forEach((item) => item.removeAttribute('id'));
			queryAll('.open, .show-submenu-child', list).forEach((item) => {
				item.classList.remove('open', 'show-submenu-child');
				item.removeAttribute('style');
			});

			queryAll('.toggle-submenu, [data-toggle="submenu"]', list).forEach(
				(toggle) => {
					toggle.setAttribute('aria-expanded', 'false');
				}
			);
			resetLinkLoadingSpinners(list);
			prepareDrilldownToggles(list);

			return list;
		};

		const getToggleTitle = (toggle) => {
			const label =
				toggle?.querySelector?.('span, .submenu-title')?.textContent ||
				toggle?.textContent ||
				'Menu';

			return label.replace(/\s+/g, ' ').trim();
		};

		const renderLayer = (direction = 'forward') => {
			const { layer, layerTitle, layerContent } = getCurrentElements();
			const currentLayer = layerStack[layerStack.length - 1];

			if (!layer || !layerTitle || !layerContent || !currentLayer) {
				return;
			}
			// Sao chép menu nguồn để mỗi layer có DOM độc lập, sau đó chuẩn hóa
			// trạng thái submenu trước khi đưa vào vùng hiển thị.
			const clonedList = sanitizeLayerList(
				currentLayer.source.cloneNode(true)
			);

			layerTitle.textContent = currentLayer.title;
			layerContent.replaceChildren(clonedList);
			layerContent.scrollTop = 0;
			layer.classList.add('is-active');
			layer.setAttribute('aria-hidden', 'false');
			window.requestAnimationFrame(() => {
				animateLayerList(
					clonedList,
					'back' === direction ? 'back-in' : 'forward-in'
				);
			});

			window.setTimeout(() => {
				layer
					.querySelector('a, button, [tabindex]:not([tabindex="-1"])')
					?.focus?.({ preventScroll: true });
			}, 120);
		};

		const getLayerListAnimationFrames = (direction) => {
			const distance = 28;
			const frames = {
				'forward-in': [
					{ opacity: 0, transform: `translate3d(${distance}px, 0, 0)` },
					{ opacity: 1, transform: 'translate3d(0, 0, 0)' },
				],
				'forward-out': [
					{ opacity: 1, transform: 'translate3d(0, 0, 0)' },
					{ opacity: 0, transform: `translate3d(-${distance}px, 0, 0)` },
				],
				'back-in': [
					{ opacity: 0, transform: `translate3d(-${distance}px, 0, 0)` },
					{ opacity: 1, transform: 'translate3d(0, 0, 0)' },
				],
				'back-out': [
					{ opacity: 1, transform: 'translate3d(0, 0, 0)' },
					{ opacity: 0, transform: `translate3d(${distance}px, 0, 0)` },
				],
			};

			return frames[direction] || frames['forward-in'];
		};

		const animateLayerList = (list, direction) => {
			if (
				!list ||
				'function' !== typeof list.animate ||
				window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches
			) {
				return Promise.resolve();
			}

			const animation = list.animate(getLayerListAnimationFrames(direction), {
				duration: 220,
				easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
				fill: 'both',
			});

			return animation.finished?.catch(() => {}) || Promise.resolve();
		};

		const closeLayer = () => {
			const { layer, layerContent, layerTitle } = getCurrentElements();
			const currentList = layerContent?.querySelector(
				'.mobile-menu-layer__list'
			);
			const animationId = ++layerAnimationId;

			layerStack.length = 0;

			animateLayerList(currentList, 'back-out').then(() => {
				if (animationId !== layerAnimationId) {
					return;
				}

				layer?.classList.remove('is-active');
				layer?.setAttribute('aria-hidden', 'true');
				layerContent?.replaceChildren();

				if (layerTitle) {
					layerTitle.textContent = '';
				}
			});
		};

		const pushLayer = (source, title) => {
			if (!source) {
				return;
			}

			const { layerContent } = getCurrentElements();
			const currentList = layerContent?.querySelector(
				'.mobile-menu-layer__list'
			);
			const animationId = ++layerAnimationId;

			animateLayerList(currentList, 'forward-out').then(() => {
				if (animationId !== layerAnimationId) {
					return;
				}

				layerStack.push({
					source,
					title,
				});
				renderLayer('forward');
			});
		};

		const getDrilldownSource = (toggle) => {
			if (!toggle) {
				return null;
			}

			if (toggle.matches('.toggle-submenu')) {
				const submenu =
					toggle.nextElementSibling?.matches?.('.sub-menu')
						? toggle.nextElementSibling
						: toggle.closest('li')?.querySelector(':scope > .sub-menu');

				return submenu || null;
			}
			if (toggle.matches('[data-toggle="submenu"]')) {
				const submenu =
					toggle.nextElementSibling?.matches?.('.submenu-child-container')
						? toggle.nextElementSibling
						: toggle.parentElement?.querySelector(
								':scope > .submenu-child-container'
						  );

				return submenu || null;
			}

			return null;
		};

		const openDrilldownLayer = (toggle, event) => {
			const source = getDrilldownSource(toggle);

			if (!source) {
				return false;
			}

			event?.preventDefault();
			event?.stopPropagation();
			toggle.setAttribute('aria-expanded', 'true');
			pushLayer(source, getToggleTitle(toggle));

			return true;
		};

		const popLayer = () => {
			const { layer, layerContent, layerTitle } = getCurrentElements();
			const currentList = layerContent?.querySelector(
				'.mobile-menu-layer__list'
			);
			const animationId = ++layerAnimationId;

			animateLayerList(currentList, 'back-out').then(() => {
				if (animationId !== layerAnimationId) {
					return;
				}

				layerStack.pop();

				if (layerStack.length > 0) {
					renderLayer('back');
					return;
				}

				layer?.classList.remove('is-active');
				layer?.setAttribute('aria-hidden', 'true');
				layerContent?.replaceChildren();

				if (layerTitle) {
					layerTitle.textContent = '';
				}
			});
		};

		const openSidebar = () => {
			const { sidebar, menuButton, menuIcon } = getCurrentElements();

			if (!sidebar) {
				return;
			}

			const offcanvas = getBootstrapOffcanvas(sidebar);

			if (!offcanvas) {
				sidebar.classList.add('show');
				sidebar.setAttribute('aria-modal', 'true');
				sidebar.removeAttribute('aria-hidden');
			}

			menuIcon.classList.add('active');
			menuButton?.setAttribute('aria-expanded', 'true');
		};

		const closeSidebar = () => {
			const { sidebar, menuButton, menuIcon } = getCurrentElements();

			if (!sidebar) {
				return;
			}

			const offcanvas = getBootstrapOffcanvas(sidebar);

			if (!offcanvas) {
				sidebar.classList.remove('open', 'show');
				sidebar.removeAttribute('aria-modal');
				sidebar.setAttribute('aria-hidden', 'true');
				closeLayer();
			}

			menuIcon.classList.remove('active');
			menuButton?.setAttribute('aria-expanded', 'false');
		};

		let linkLoadingResetTimer = null;
		// clear the link loading reset timer on sidebar close
		const clearLinkLoadingResetTimer = () => {
			if (!linkLoadingResetTimer) {
				return;
			}

			window.clearTimeout(linkLoadingResetTimer);
			linkLoadingResetTimer = null;
		};

		const resetSidebarLinkSpinners = () => {
			clearLinkLoadingResetTimer();
			resetLinkLoadingSpinners(cachedElements.sidebar || document);
		};

		this.mobileMenuResetSpinners = resetSidebarLinkSpinners;

		const showLinkLoadingSpinner = (link, event) => {
			if (
				!link ||
				event.defaultPrevented ||
				event.ctrlKey ||
				event.metaKey ||
				event.shiftKey ||
				event.altKey ||
				0 !== event.button
			) {
				return;
			}

			const icon = link.nextElementSibling;

			if (!icon?.classList.contains('fa-circle-chevron-right')) {
				return;
			}

			icon.classList.replace('fa-circle-chevron-right', 'fa-circle-notch');
			icon.classList.add('fa-spin');
			link.dataset.currentLoadingContent = link.textContent;
			link.textContent = 'Đang tải...';
			clearLinkLoadingResetTimer();
			linkLoadingResetTimer = window.setTimeout(
				resetSidebarLinkSpinners,
				10000
			);
		};
		// event listener on the link elements to direct to the page
		document.addEventListener('click', (event) => {
			const directMenuLink = event.target.closest(
				'.menu-main > ul > li.menuli[data-href="true"] a'
			);
			if (directMenuLink) {
				event.preventDefault();
				const href = directMenuLink.getAttribute('href');
				if (href) {
					window.location.href = href;
				}
				return;
			}

			const { sidebar, menuButton } = getCurrentElements();

			if (!sidebar || !menuButton) {
				return;
			}
			// Mở sidebar
			if (event.target.closest('.icon-menu')) {
				event.preventDefault();
				event.stopPropagation();
				openSidebar();
				return;
			}
			// Đóng sidebar
			if (
				event.target.closest('#header-close-btn')
			) {
				event.preventDefault();
				closeSidebar();
				return;
			}
			// Back về menu chính của sidebar
			if (event.target.closest('[data-mobile-menu-back]')) {
				event.preventDefault();
				popLayer();
				return;
			}

			const loadingLink = event.target.closest(
				'[data-mobile-menu-loading-link]'
			);

			if (loadingLink && sidebar.contains(loadingLink)) {
				// calling the function to reset the spinners by clearing the timer and the current loading on sidebar
				resetSidebarLinkSpinners();
				// calling the function to show the loading spinner
				showLinkLoadingSpinner(loadingLink, event);
			}

			const drilldownToggle = event.target.closest(
				'.toggle-submenu, [data-toggle="submenu"]'
			);
			// Chỉ xử lý nút mở submenu thuộc sidebar; nếu đã mở được một lớp drilldown thì dừng xử lý click tiếp.
			if (
				drilldownToggle &&
				sidebar.contains(drilldownToggle) &&
				openDrilldownLayer(drilldownToggle, event)
			) {
				return;
			}

			if (
				!window.bootstrap?.Offcanvas &&
				!sidebar.contains(event.target) &&
				!menuButton.contains(event.target)
			) {
				closeSidebar();
			}
		});

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				closeSidebar();
				return;
			}

			if (
				'Enter' !== event.key &&
				' ' !== event.key &&
				'Spacebar' !== event.key
			) {
				return;
			}

			const { sidebar } = getCurrentElements();
			const drilldownToggle = event.target.closest?.(
				'[data-toggle="submenu"]'
			);

			if (
				sidebar &&
				drilldownToggle &&
				sidebar.contains(drilldownToggle)
			) {
				openDrilldownLayer(drilldownToggle, event);
			}
		});

		const { sidebar } = getCurrentElements();
		if (sidebar) {
			prepareDrilldownToggles(sidebar);
		}

		sidebar?.addEventListener('hidden.bs.offcanvas', () => {
			getCurrentElements().menuButton?.setAttribute(
				'aria-expanded',
				'false'
			);
			resetSidebarLinkSpinners();
			closeLayer();
		});

		if (this.windowDimensions.width <= 1024) {
			this.$(' .menu-main > ul > li.menuli > a')
				.off('click.jwTheme')
				.on('click.jwTheme', function(event) {
					event.preventDefault();
					$(this).next('.submenu-layer-list').toggle();
				});
		}
	}

	initTabSwitching() {
		this.$(document).off('click.jwThemeStories', '#stories .customer-avatars .item').on('click.jwThemeStories', '#stories .customer-avatars .item', (event) => {
			event.preventDefault();
			const current = this.$(event.currentTarget).find('a').data('tab');
			this.changeStories(current);
		});

		this.$(document).off('click.jwThemeStoriesDots', '#stories .slick-dots li').on('click.jwThemeStoriesDots', '#stories .slick-dots li', (event) => {
			const current = this.$(event.currentTarget).find('button').text();
			this.changeStories(current);
		});

		this.$(document).off('click.jwThemeWhy', '.why .why-content .cer-item').on('click.jwThemeWhy', '.why .why-content .cer-item', (event) => {
			event.preventDefault();
			const current = this.$(event.currentTarget).data('tab');
			window.requestAnimationFrame(() => {
				this.$('.why .why-content .tab').removeClass('active');
				this.$(`.why .why-content .tab[data-id="${current}"]`).addClass('active');
			});
		});

		this.$('.news-items').off('mouseenter.jwTheme').on('mouseenter.jwTheme', 'li', function() {
			$(this).closest('.news-items').find('li').removeClass('active');
			$(this).addClass('active');
		});
	}

	changeStories(currentActive) {
		window.requestAnimationFrame(() => {
			this.$('#stories .stories-info .customer-tab').removeClass('active');
			this.$(`#stories .stories-info .customer-tab[data-id="${currentActive}"]`).addClass('active');
		});
	}

	initDoctorGallery() {
		this.$('.doctor span.dg-arrow').off('click.jwTheme').on('click.jwTheme', () => {
			window.setTimeout(() => this.changeDoctor(), 300);
		});

		this.$('.customer-slick-vertical').off('click.jwTheme', '.slick-arrow').on('click.jwTheme', '.slick-arrow', () => {
			window.requestAnimationFrame(() => {
				const current = this.$('.customer-slick-vertical')
					.find('.slick-slide.slick-active:eq(0)')
					.find('a')
					.data('tab');
				this.changeStories(current);
			});
		});
	}

	changeDoctor(currentTab = null) {
		window.requestAnimationFrame(() => {
			const resolvedTab = currentTab
				|| document.querySelector('#dr-container .dg-center .doctor-item')?.dataset.id;

			if (!resolvedTab) {
				return;
			}

			document.querySelectorAll('.doctor .doctor-tab').forEach((tab) => {
				tab.classList.remove('active');
			});

			document.getElementById(resolvedTab)?.classList.add('active');
		});
	}

	initVideoPlayer() {
		this.$('.owl_video .intro-video').off('click.jwTheme').on('click.jwTheme', (event) => {
			if (this.windowDimensions.width >= 991) {
				return;
			}

			const current = this.$(event.currentTarget).find('.play-button').data('embed');
			this.$('.preview-intro-video')
				.find('.play-button')
				.attr('data-embed', current)
				.trigger('click');
		});
	}

	initYoutubeEmbeds() {
		document.querySelectorAll('.youtube').forEach((container) => {
			const embedId = container.dataset.embed;
			if (!embedId) {
				return;
			}

			if (!container.querySelector('img')) {
				const image = new Image();
				image.src = `https://img.youtube.com/vi/${embedId}/sddefault.jpg`;
				image.alt = 'thammyhanquoc.vn';
				image.className = 'lazyload';
				image.addEventListener('load', () => {
					if (!container.querySelector('img')) {
						container.appendChild(image);
					}
				});
			}

			container.addEventListener('click', () => {
				const iframe = document.createElement('iframe');
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('class', 'youtube-video');
				iframe.setAttribute('allowfullscreen', '');
				iframe.setAttribute('src', `https://www.youtube.com/embed/${embedId}?rel=0&showinfo=0&autoplay=1`);
				container.innerHTML = '';
				container.appendChild(iframe);
			}, { once: true });
		});
	}

	initFloatingContactToggles() {
		this.$('.hide_float_right a').off('click.jwTheme').on('click.jwTheme', (event) => {
			event.preventDefault();
			this.$('#float_content_right').toggle();
			const $icon = this.$(event.currentTarget).find('i');
			if ($icon.hasClass('fa-arrow-down')) {
				$icon.removeClass('fa-arrow-down').addClass('fa-arrow-up');
				return;
			}

			$icon.removeClass('fa-arrow-up').addClass('fa-arrow-down');
		});

		this.$('.hide_float_right a').off('mouseover.jwTheme').on('mouseover.jwTheme', (event) => {
			event.preventDefault();
			this.$('#float_content_right').show();
			this.$(event.currentTarget).find('i').removeClass('fa-arrow-up').addClass('fa-arrow-down');
			sessionStorage.bannerBottom = 'show';
		});
	}

	initStickyTargets() {
		if (typeof this.$.fn.lazyload === 'function') {
			this.$('.lazyload').lazyload({ effect: 'fadeIn' });
		}

		if (this.windowDimensions.width > 768 && typeof this.$.lockfixed === 'function') {
			const footerHeight = this.$('footer.footer-main').outerHeight() || 0;
			this.$.lockfixed('.popular-fix', {
				offset: {
					top: 50,
					bottom: footerHeight + 20,
				},
			});
		}

		const stickyImg = document.querySelector('.sticky-testimonial img');
		if (stickyImg && typeof this.$.lockfixed === 'function' && this.windowDimensions.width > 991) {
			this.$.lockfixed('.sticky-testimonial img', {
				offset: {
					top: 340,
					bottom: 646,
				},
			});
		}
	}

	initScrollProgress() {
		this.progressBars = document.querySelectorAll('.scroll-progress__bar');
		if (!this.progressBars.length) {
			return;
		}

		window.addEventListener('scroll', this.handleProgressScroll, { passive: true });
		this.updateProgress();
	}

	handleProgressScroll() {
		if (this.progressTicking) {
			return;
		}

		this.progressTicking = true;
		window.requestAnimationFrame(() => this.updateProgress());
	}

	updateProgress() {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
		const scrollPercentage = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
		this.progressBars?.forEach((bar) => {
			bar.style.width = `${scrollPercentage}%`;
		});
		this.progressTicking = false;
	}

	initIconDismiss() {
		document.querySelectorAll('.icon-close-btn').forEach((button) => {
			const dismiss = (event) => {
				event.preventDefault();
				event.stopPropagation();
				event.target.closest("[id^='icon-']")?.style.setProperty('display', 'none');
			};

			button.addEventListener('click', dismiss);
			button.addEventListener('touchstart', dismiss);
		});
	}

	handleHeaderScroll() {
		if (this.windowDimensions.width <= 1024) {
			return;
		}

		const shouldFix = this.$(window).scrollTop() >= (this.$('header').outerHeight() || 0) - 10;
		this.$('header.main-head').toggleClass('fixed-header', shouldFix);
		this.$(':is(.menu-main, .header-sidebar) ul li .sub-menu').toggleClass('scroll-submenu-fix', shouldFix);
	}

	handleResponsiveAdjustments() {
		window.requestAnimationFrame(() => {
			const reportLast = document.querySelector('.doctor-report .list > div:last-child');
			const achievementLast = document.querySelector('.doctor-achievement .list > div:last-child');

			if (reportLast) {
				reportLast.classList.remove('col-sm-6');
				reportLast.classList.add('col-sm-12');
			}

			if (achievementLast) {
				achievementLast.classList.remove('col-sm-6');
				achievementLast.classList.add('col-sm-12');
			}
		});
	}

	onResize() {
		this.updateWindowCache();
		this.clearLayoutCache();
		if (this.$('#dr-container').length && typeof this.$.fn.gallery === 'function') {
			this.$('#dr-container').gallery();
		}
		this.positionDropdownMenus();
		this.initMenuBehavior();
		this.handleResponsiveAdjustments();
		this.handleHeaderScroll();
	}

	handleWindowOrientation() {
		this.clearLayoutCache();
		this.onResize();
	}
}
